import React from 'react'

import Topbar from '../Topbar'
import Organization from './components/Organization'
import ExtraAdmins from './components/ExtraAdmins'
import Version from './components/Version'

import * as organizationService from '../../services/organization-service'

export default class Account extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.updateOrganization = this.updateOrganization.bind(this)
    this.getOrganization = this.getOrganization.bind(this)

    this.state = {
      organization: undefined
    }
  }

  componentDidMount() {
    this.getOrganization()
  }

  getOrganization() {
    organizationService.getOrganization().then((data) => this.setState({ organization: data }))
  }

  updateOrganization(organization) {
    organizationService.upsertOrganization(organization).then(() => this.getOrganization())
  }

  render() {

    const { organization } = this.state

    return (
      <div className="content table-page col-2 account">
        <div className="content-inner">
          <Topbar title="Account" />

          <div className="inner">
            <div className="row">
              <div className="col">
                <h2>Persoonlijke gegevens</h2>
                {organization && <Organization organization={organization} updateCallback={this.updateOrganization} />}
              </div>
              <div className="col">
                <div className="row">
                  <div className="col">
                    <h2>Medebeheerders</h2>
                    {(organization && organization.extraAdminDTOS) && <ExtraAdmins organization={organization.id} />}
                  </div>
                  <div className="col">
                    <h2>Versie</h2>
                    {(organization) && <Version organization={organization} updateCallback={this.updateOrganization} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Account/index.js